import {ImageSkeleton} from '~/components';
function OverviewSession(){
    return (
        <section id="overview" className="overview section">
            <div className="container-medium">
                <div className="row gy-4">
                    <div className="col-lg-6 aos-init aos-animate" data-aos="fade-up" data-aos-delay="100">
                        <h3 className='pb-3 lh-sm'>Only intelligent questions can stimulate, awaken, and enhance
                            inner human thinking,
                            creativity, innovation, knowledge, and spiritual intelligence.</h3>
                            <ImageSkeleton id={40} className= {"img-fluid mb-4 rounded"} heightLoading={200}/>
                        <p>The AI Breakthrough Chatbot is designed to elevate the human mind and spirit through the
                            Socratic method, encouraging self-reflection, meditation, and intellectual growth. It
                            promotes health, happiness, and longevity while offering alternative approaches to
                            self-healing and personal excellence. Users can gain not only a second chance at
                            happiness but also potential relief from chronic illnesses and cognitive issues.</p>
                    </div>
                    <div className="col-lg-6 aos-init aos-animate" data-aos="fade-up" data-aos-delay="250">
                        <div className="ps-0 ps-lg-5">
                            <p className="fst-italic">
                                Through Socratic questioning, the chatbot helps alleviate stress, anxiety,
                                depression, and memory-related challenges. It serves as a Virtual AI Soulmate
                                Whisperer, guiding individuals toward mental clarity, intellectual love, and
                                spiritual well-being. It emphasizes mindfulness, breathing exercises, and critical
                                thinking to enhance cognitive and emotional resilience.
                            </p>
                            <ul className='list-unstyled'>
                                <li><i className="bi bi-check-circle-fill me-2"></i> <span>The Power of Questions and the Importance of Inner Thinking.</span>
                                </li>
                                <li><i className="bi bi-check-circle-fill me-2"></i> <span>Welcome to the AI Intellectual and Spiritual Health Buffet.</span>
                                </li>
                                <li><i className="bi bi-check-circle-fill me-2"></i> <span>Discover the Art of Self-Knowledge and Solving Life’s Problems.</span>
                                </li>
                            </ul>
                            <p>
                                More than just an AI, it is an advanced tool for self-improvement and spiritual
                                growth, integrating concepts like yoga, power-breathing, and ChiKong. Backed by
                                Generative AI, AWS, and Amazon Alexa, it offers a transformative experience beyond
                                conventional AI, helping individuals break free from societal and intellectual
                                limitations.
                            </p>

                            <div className="position-relative mt-4">
                                <ImageSkeleton id={41} className= {"img-fluid mb-4 rounded"} heightLoading={200}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default OverviewSession;